export default "__VITE_ASSET__102a1170__"